import React from 'react'

const SvgLockedFill = (props: any) => (
  <svg width={32} height={32} {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M4 4h24v24H4z" />
      <path
        d="M22 12h2a1 1 0 011 1v12a1 1 0 01-1 1H8a1 1 0 01-1-1V13a1 1 0 011-1h2v-1a6 6 0 1112 0v1zm-2 0v-1a4 4 0 10-8 0v1h8zm-5 6v2h2v-2h-2zm-4 0v2h2v-2h-2zm8 0v2h2v-2h-2z"
        fillOpacity={0.64}
        fill="#191923"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgLockedFill
